import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchTrialData = (type, code = null) => {
  const params = new URLSearchParams({ type });
  if (code) {
    params.append('code', code);
  }
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/opnbal/trial-data?${params}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const batchUpdateOpnBal = (data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/opnbal/batch`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOutstandingDocuments = (vendorId, customerId) => {
  const params = new URLSearchParams({ 
    vendorId, 
    customerId 
  });
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/opnbal/outstanding-documents?${params}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const saveOutstandingDocuments = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/opnbal/outstanding-documents`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
